<template>
  <div>
    <h3>Create NFTstitches</h3>
    <div v-if="isShowResults">
      <table>
        <td>Result</td>
        <tr>
          <ul id="results-nftmint" class="left">
            <li>
              <h4>IPFS CID NFT: ipfs://{{ results.nftDto.cidNft }}</h4>
              <h4>IPFS CID Metadata: ipfs://{{ results.nftDto.cidMeta }}</h4>
              <h4>
                <a
                  v-bind:href="
                    'https://nftmaster.com/NFT/' + results.nftDto.xrpNftId
                  "
                >
                  {{ results.nftDto.xrpNftId }}</a
                >
              </h4>
              <h2>Scan with Xaman to mint on the XRPL</h2>
              <div id="mintQr"></div>
            </li>
          </ul>
        </tr>
      </table>
    </div>
    <div class="spinner-displayer">
      <img src="@/assets/images/logo.png" width="75" />
      <p></p>
    </div>
    <form id="mintNftForm" @submit="mintNft">
      <label class="error" v-html="message" />

      <hr />
      <div class="form-group">
        <label>Name</label>
        <input
          title="Enter the name of your NFT that will link to others."
          type="text"
          v-model="name"
          class="form-control form-control-lg"
        />
      </div>
      <div class="form-group">
        <label
          >Your XRP address (You'll need this address in Xaman to approve the
          mint transaction)</label
        >
        <input
          title="XRP address that should own this NFT"
          type="text"
          v-model="xrpAddress"
          class="form-control form-control-lg"
        />
      </div>
      <div class="form-group">
        <label>Created by</label>
        <input
          title="Who created the NFT (Organization or person)"
          type="text"
          v-model="artist"
          class="form-control form-control-lg"
        />
      </div>

      <div class="form-group">
        <label>Description</label>
        <input
          title="Description of the NFT"
          type="text"
          v-model="description"
          class="form-control form-control-lg"
        />
      </div>

      <div class="form-group">
        <label>Business Name</label>
        <input
          title="What is the name of the business that owns this NFT"
          type="text"
          v-model="business"
          class="form-control form-control-lg"
        />
      </div>
      <div class="form-group">
        <label>Product Name</label>
        <input
          title="What is the name of the product.  You can have many NFTs usings the same product name"
          type="text"
          v-model="product"
          class="form-control form-control-lg"
        />
      </div>
      <!--div class="form-group">
        <label
          >Taxon (This is a number you can reuse to group of a set of
          NFTstitches)</label
        >
        <input
          title="Maybe put a 9 digit number in here that you will use for your NFTs.  Must be less than 4,294,967,295"
          type="text"
          v-model="taxon"
          class="form-control form-control-lg"
        />
      </div-->
      <div class="form-group">
        <button type="button" @click="addNftlink()" class="secondary-button">
          Add NFT links
        </button>
        <h3>
          If no links are added, it will still create the NFT without links
        </h3>
        <div v-for="(nftlink, index) in nftlinks" :key="index">
          <div class="flex justify-start ml-2 mt-4">
            <input v-model="nftlink.value" placeholder="XRP NFT Token Id" />
            <i class="fas fa-trash-alt" @click="removeNftLink(index)"></i>
          </div>
        </div>
      </div>
      <div class="form-group">
        <button type="button" @click="addAttribute()" class="secondary-button">
          Add custom attribute
        </button>

        <div v-for="(attribute, index) in attributes" :key="index">
          <div class="flex justify-start ml-2 mt-4">
            <input v-model="attribute.key" placeholder="Attribute name" /> -
            <input v-model="attribute.value" placeholder="Attribute value" />
            <i class="fas fa-trash-alt" @click="removeAttribute(index)"></i>
          </div>
        </div>
      </div>
      <div class="form-group">
        <label>NFT File to Upload</label>
        <h4>
          This can be a generated image, picture of the item, image of a
          document or any image you like.
        </h4>
        <input
          type="file"
          id="file"
          ref="file"
          v-on:change="handleFileUpload()"
        />
      </div>

      <div class="form-group">
        <label
          >Remove any metadata from the image you are uploading
          <input
            title="Remove any exif metadata from the file if JPG"
            type="checkbox"
            v-model="cleanMetadata"
            class="form-control form-control-lg"
        /></label>
      </div>
      <button type="submit" id="btn" :disabled="false">Mint NFT</button>

      <p><label v-html="fee" /></p>
      <router-link class="nav-link pr-3" to="/terms"
        >Terms & Conditions</router-link
      >
      <router-link class="nav-link pr-3" to="/privacy"
        >Privacy Policy</router-link
      >
    </form>
  </div>
</template>

<script>
export default {
  name: "xrplnftmint",
  data: function () {
    return {
      results: "",
      pubKey: "",
      name: "",
      description: "",
      artist: "",
      file: "",
      fee: "There is no upfront fee to mint.  There is only a fee to transfer the NFT.",
      isShowResults: false,
      message: "",
      cleanMetadata: true,
      taxon: 0,
      business: "",
      xrpAddress: "",
      product: "",
      attributes: [],
      nftlinks: [],
    };
  },
  components: {},
  methods: {
    removeAttribute(index) {
      this.attributes.splice(index, 1);
    },
    removeNftLink(index) {
      this.nftlinks.splice(index, 1);
    },
    xummQrCode: function () {
      var dto = {};
      dto.TransferFee = "0";
      dto.Account = this.results.nftDto.recipientXrpAddress;
      dto.NFTokenTaxon = this.results.taxon;
      dto.Flags = this.results.flags;
      dto.URI = this.results.nftDto.cidMeta;

      var jsonbody = JSON.stringify(dto);
      const requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: jsonbody,
      };
      this.isShowResults = true;
      fetch(
        this.$xummhost +
          "/nftokenmint/" +
          this.results.nftDto.id +
          "?redirect=https://nftstitches.com/#/xrplnftaccept",
        requestOptions
      )
        .then((response) => response.json())
        .then((data) => {
          var img = document.createElement("img");
          img.src = data.refs.qr_png;
          var src = document.getElementById("mintQr");
          src.appendChild(img);
        });
    },
    addAttribute() {
      this.attributes.push({ name: "", value: "" });
    },
    addNftlink() {
      this.nftlinks.push({ value: "" });
    },
    verifyInputs(dto) {
      if (dto.name.length < 1) {
        this.message = "Name is invalid";
        return false;
      }
      if (dto.description.length < 1) {
        this.message = "Description is invalid";
        return false;
      }
      if (dto.artist.length < 1) {
        this.message = "Artist is invalid";
        return false;
      }
      if (dto.collectionFamily.length < 1) {
        this.message = "Business is invalid";
        return false;
      }
      if (dto.collectionName.length < 1) {
        this.message = "Product is invalid";
        return false;
      }
      if (dto.taxon > 4294967295) {
        this.message = "Taxon must be less than 4,294,967,295";
        return false;
      }
      if (dto.xrpAddress.length < 1) {
        this.message = "XRP Address is invalid";
        return false;
      }
      if (this.file.length < 1) {
        this.message = "A file upload is required";
        return false;
      }
      return true;
    },
    spinner: function () {
      const spinnerDisplayer = document.querySelector(".spinner-displayer");
      spinnerDisplayer.classList.add("loading");
    },
    handleFileUpload() {
      this.file = this.$refs.file.files[0];
    },
    mintNft: function (e) {
      e.preventDefault();
      window.scrollTo(0, 0);

      //TODO
      //document.getElementById("mintQr").removeChild;

      var dto = {};
      dto.name = this.name;
      dto.artist = this.artist;
      dto.description = this.description;
      dto.cleanMetadata = this.cleanMetadata;
      dto.props = this.attributes;
      dto.nftlinks = this.nftlinks;
      dto.taxon = this.taxon;
      dto.collectionFamily = this.business;
      dto.collectionName = this.product;
      dto.xrpAddress = this.xrpAddress;

      if (!this.verifyInputs(dto)) {
        return;
      }
      this.spinner();
      this.message = "";
      this.results = "";

      let formData = new FormData();
      formData.append("file", this.file);
      formData.append("nft", JSON.stringify(dto));

      this.message = "";
      const requestOptions = {
        method: "POST",
        body: formData,
      };

      fetch(this.$nfthost + "/nftstitches/nft/", requestOptions)
        .then((response) => response.json())
        .then((data) => {
          document
            .querySelector(".spinner-displayer")
            .classList.remove("loading");

          if (data.status && data.status != 200) {
            this.message = "Minting failed, please retry. " + data.message;
            return;
          }
          console.log(data);
          if (!data || data.length <= 0) {
            this.message = "Minting failed, please retry";
          } else {
            this.results = data;
            this.xummQrCode();
          }
        })
        .catch((e) => {
          document
            .querySelector(".spinner-displayer")
            .classList.remove("loading");
          this.results = e;
        });
    },
  },
};
</script>

